
import { HttpParams } from "@angular/common/http";

export interface NotificationForUser {
    id: string;
    title: string;
    message: string;
    fileStorageLocation: string;
    createdOn: Date;
}

export interface UnreadNotificationForUser {
    id: string;
    title: string;
    message: string;
    fileStorageLocation: string;
    createdOn: Date;
}

export interface NotificationCreatedByUser {
    id: string;
    title: string;
    message: string;
    fileStorageLocation: string;
    createdOn: Date;
    recipients: NotificationRecipient[];
}

export interface NotificationRecipient {
    associationId: string;
    associationName: string;
}


export interface CreateNotification {
    createdById: string;
    title: string;
    message: string;
    fileStorageLocation: string;
    associationIds: string[];
    deliveryChannelIds: string[];
}

export interface MarkNotificationAsDelivered {
    notificationId: string, 
    userId: string
}

export class GetAllNotificationsForUserFilter {
  constructor(
    public userId?: string | null,
    public year?: number | null
  ) {}

  toQueryParams(): HttpParams {
    let params = new HttpParams();
    
    if (this.userId) {
      params = params.set('userId', this.userId);
    }
    
    if (this.year !== null && this.year !== undefined) {
      params = params.set('year', this.year.toString());
    }
    
    return params;
  }
}

export class GetUnreadNotificationsForUserFilter {
  constructor(
    public userId?: string | null,
    public year?: number | null
  ) {}

  toQueryParams(): HttpParams {
    let params = new HttpParams();
    
    if (this.userId) {
      params = params.set('userId', this.userId);
    }
    
    if (this.year !== null && this.year !== undefined) {
      params = params.set('year', this.year.toString());
    }
    
    return params;
  }
}

export class GetNotificationsCreatedByUserFilter {
  constructor(
    public createdById?: string | null,
    public year?: number | null
  ) {}

  toQueryParams(): HttpParams {
    let params = new HttpParams();
    
    if (this.createdById) {
      params = params.set('createdById', this.createdById);
    }
    
    if (this.year !== null && this.year !== undefined) {
      params = params.set('year', this.year.toString());
    }
    
    return params;
  }
}

